/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Download_PreparingInputs */

const en_mobile_download_preparing = /** @type {(inputs: Mobile_Download_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing download…`)
};

const es_mobile_download_preparing = /** @type {(inputs: Mobile_Download_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando la descarga…`)
};

/**
* | output |
* | --- |
* | "Preparing download…" |
*
* @param {Mobile_Download_PreparingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_download_preparing = /** @type {((inputs?: Mobile_Download_PreparingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Download_PreparingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_download_preparing(inputs)
	return en_mobile_download_preparing(inputs)
});